import { Box } from "@mui/material";
import SecondaryBox from "../../atoms/box/SecondaryBox";
import { RectangularLoader } from "../../molecules/skeleton-loader/RectangularLoader";
import { ScreenSmallerThen } from "../../utilities/UIHelper";

export const CustomLayoutDetailsLoader = () => {
  const isSmallScreen = ScreenSmallerThen();
  return (
    <SecondaryBox>
      <Box width="100%" display="flex" gap="10px" justifyContent="space-between">
        {[...Array(2)].map((_, idx) => (
          <Box
            display="flex"
            flexDirection="column"
            width="100%"
            gap="10px"
            flexGrow={1}
            maxWidth={isSmallScreen ? "100%" : "48%"}
          >
            <RectangularLoader maxWidth="229px" height="30px" />
            <RectangularLoader maxWidth="100%" height="60px" />
            <RectangularLoader maxWidth="229px" height="30px" />
            <RectangularLoader maxWidth="100%" height="60px" />
            <RectangularLoader maxWidth="229px" height="30px" />
            <RectangularLoader maxWidth="100%" height="60px" />
          </Box>
        ))}
      </Box>
    </SecondaryBox>
  );
};
